import {Badge, Box, IconButton, InputAdornment, Typography} from "@mui/material";
import React from "react";
import CommonColorUtils from "../utils/common_colors";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

export default function FilterComponent({count, label = "Filter", Icon, onClick}) {
    return <Box
        sx={{
            display: "flex",
            alignItems: "center",
            border: "1px solid #E0E0E0",
            borderRadius: "8px",
            padding: "8px 15px",
            gap: "15px",
            width: "auto",
            height: "30px",
            marginTop: "15px"
        }}
    >
        {count > 0 && <Badge
            badgeContent={count}
            sx={{
                "& .MuiBadge-badge": {
                    borderRadius: "50%",
                    width: "20px",
                    height: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: CommonColorUtils.primaryMainBlue,
                    color: CommonColorUtils.primaryKWhite
                },
            }}
        />}


        <Typography
            sx={{
                fontSize: "14px",
                fontWeight: 500,
                color: "#6F727A",
            }}
        >
            {label}
        </Typography>


        {Icon && <InputAdornment position="end">
            <IconButton
                onClick={onClick}
                sx={{
                    paddingRight: "0px",
                    color: "#6F727A",
                    backgroundColor: "transparent", // Set background color to transparent
                    '&:hover': {
                        backgroundColor: "transparent", // Ensure the background stays transparent on hover
                        color: "#3F51B5", // Change the color of the icon on hover (you can customize this color)
                    },
                }}

            >
                <Icon/>
            </IconButton>
        </InputAdornment>}



    </Box>
}